// Songs.js
import React, { useRef, useState, useEffect } from 'react';
import './Episodes.css';

import pianooo from '../assets/pianooo.PNG';
import cartiwannagotopluto from '../assets/cartiwannagotopluto.png';

const pianoNotes = [
  { note: 'C4', freq: 261.63, type: 'white' },
  { note: 'C#4', freq: 277.18, type: 'black' },
  { note: 'D4', freq: 293.66, type: 'white' },
  { note: 'D#4', freq: 311.13, type: 'black' },
  { note: 'E4', freq: 329.63, type: 'white' },
  { note: 'F4', freq: 349.23, type: 'white' },
  { note: 'F#4', freq: 369.99, type: 'black' },
  { note: 'G4', freq: 392.0, type: 'white' },
  { note: 'G#4', freq: 415.3, type: 'black' },
  { note: 'A4', freq: 440.0, type: 'white' },
  { note: 'A#4', freq: 466.16, type: 'black' },
  { note: 'B4', freq: 493.88, type: 'white' },

  { note: 'C5', freq: 523.25, type: 'white' },
  { note: 'C#5', freq: 554.37, type: 'black' },
  { note: 'D5', freq: 587.33, type: 'white' },
  { note: 'D#5', freq: 622.25, type: 'black' },
  { note: 'E5', freq: 659.25, type: 'white' },
  { note: 'F5', freq: 698.46, type: 'white' },
  { note: 'F#5', freq: 739.99, type: 'black' },
  { note: 'G5', freq: 783.99, type: 'white' },
  { note: 'G#5', freq: 830.61, type: 'black' },
  { note: 'A5', freq: 880.0, type: 'white' },
  { note: 'A#5', freq: 932.33, type: 'black' },
  { note: 'B5', freq: 987.77, type: 'white' },
];

const songs = [
  { title: 'All You Find Is (Air)', artist: 'Desiderata', length: '3:56' },
  { title: 'Wesley\'s Theory', artist: 'Kendrick Lamar', length: '4:47' },
  { title: 'The Basement', artist: 'Lunar Vacations', length: '4:37' },
  { title: 'Forget Me Not', artist: 'Say She She', length: '3:56' },
  { title: 'Noise', artist: 'Beat Happening', length: '3:21' },
];

function Songs() {
  const audioCtxRef = useRef(null);
  const [activeNote, setActiveNote] = useState(null);
  const [selectedSong, setSelectedSong] = useState(0);

  const getAudioContext = () => {
    if (!audioCtxRef.current) {
      audioCtxRef.current = new (window.AudioContext || window.webkitAudioContext)();
    }
    return audioCtxRef.current;
  };

  const playPianoNote = async (freq, label) => {
    try {
      const ctx = getAudioContext();

      if (ctx.state === 'suspended') {
        await ctx.resume();
      }

      const osc = ctx.createOscillator();
      const gain = ctx.createGain();

      osc.type = 'triangle';
      osc.frequency.setValueAtTime(freq, ctx.currentTime);

      gain.gain.setValueAtTime(0.0001, ctx.currentTime);
      gain.gain.exponentialRampToValueAtTime(0.22, ctx.currentTime + 0.01);
      gain.gain.exponentialRampToValueAtTime(0.0001, ctx.currentTime + 0.8);

      osc.connect(gain);
      gain.connect(ctx.destination);

      osc.start(ctx.currentTime);
      osc.stop(ctx.currentTime + 0.85);

      setActiveNote(label);
      setTimeout(() => setActiveNote(null), 150);
    } catch (err) {
      console.error('Piano note error:', err);
    }
  };

  useEffect(() => {
    return () => {
      if (audioCtxRef.current) {
        audioCtxRef.current.close().catch(() => {});
      }
    };
  }, []);

  return (
  <div className="songs-page">
    <div className="playlist-panel">
      <h2 className="playlist-title">playlist</h2>
      <p className="playlist-subtitle">current favorites</p>

      <div className="playlist-list">
        {songs.map((song, i) => (
          <button
            key={song.title}
            type="button"
            className={`playlist-row ${selectedSong === i ? 'selected' : ''}`}
            onClick={() => setSelectedSong(i)}
          >
            <span className="playlist-index">{String(i + 1).padStart(2, '0')}</span>

            <span className="playlist-meta">
              <span className="playlist-song-title">{song.title}</span>
              <span className="playlist-artist">{song.artist}</span>
            </span>

            <span className="playlist-length">{song.length}</span>
          </button>
        ))}
      </div>
    </div>

    <div className="mini-piano-wrap">
      <div className="play">
        <h2>play your song</h2>
      </div>

      <div className="mini-piano">
        {pianoNotes.map((key) => (
          <button
            key={key.note}
            type="button"
            className={`piano-key ${key.type} ${activeNote === key.note ? 'active' : ''}`}
            onClick={() => playPianoNote(key.freq, key.note)}
            title={key.note}
          >
            {key.type === 'white' ? <span>{key.note}</span> : null}
          </button>
        ))}
      </div>
    </div>

    <img src={pianooo} alt="Piano" className="piano-image" />
    <img src={cartiwannagotopluto} alt="Carti" className="carti-words" />
  </div>
);
}

export default Songs;